import { render } from "./lightbox.vue?vue&type=template&id=76a4239f&scoped=true"
import script from "./lightbox.vue?vue&type=script&lang=js"
export * from "./lightbox.vue?vue&type=script&lang=js"

import "./lightbox.vue?vue&type=style&index=0&id=76a4239f&scoped=true&lang=css"

import exportComponent from "/var/www/__kickoff-23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a4239f"]])

export default __exports__